import { Box, Flex, AspectRatio, Image } from "@chakra-ui/react"

export default function Hero({ block, colorMode }) {
    const { logo, video, backgroundImage, backgroundColor, maxWidth, marginLeft = "0px" } = block

    const layoutMaxWidth = 1500

    return (
        <Flex
            className={"hero"}
            position="relative"
            overflow="hidden"
            backgroundColor={backgroundColor ? backgroundColor : "black"}
            w="100%"
        >
            <AspectRatio
                ratio={{
                    base: 3 / 3,
                    lg: layoutMaxWidth / 600,
                    xxl: layoutMaxWidth / 460,
                }}
                width="100%"
                maxHeight="500px"
                max-width={"1200px"}
                margin="0 auto"
            >
                {video && video.length != 0 ? (
                    <Box
                        as="video"
                        autoPlay
                        muted
                        playsInline
                        loop
                        src={video[0].url}
                        poster={backgroundImage[0].url}
                    />
                ) : (
                    <Image src={backgroundImage[0].url} />
                )}
            </AspectRatio>
            <Flex
                direction="column"
                align="center"
                backgroundSize="cover"
                px="20px"
                position="absolute"
                top="0"
                left="0"
                w="100%"
                h="100%"
            >
                <Box
                    w="100%"
                    h="100%"
                    maxW={{
                        xl: "1500px",
                    }}
                    px={["0px", "20px", "20px"]}
                >
                    <Flex alignItems="center" justifyContent="left" h="100%" w={"100%"} className={"logoWrapper"}>
                        <Image
                            className={"heroLogo"}
                            src={logo[0].url}
                            alt={"meeting"}
                            width={"100%"}
                            mb="0px"
                            ml={{ base: marginLeft }}
                            maxWidth={["100%", "80%", "50%", maxWidth ? maxWidth : "35%"]}
                            //maxHeight={{base: "80%", md: "80%", lg: "80%"}}

                            css={{
                                "@media screen and (max-width: 1275px)": {
                                    ml: "0px",
                                },
                            }}
                        />
                        <br />
                        <br />
                        <br />
                    </Flex>
                </Box>
            </Flex>
        </Flex>
    );
}
